var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ab-button--white ab-button--delete ab-button--icon",on:{"click":function($event){return _vm.$emit('delete')}}},[_c('i',{staticClass:"icon-icon-trash"})])
}
var staticRenderFns = []

export { render, staticRenderFns }